import type { MailboxInfo } from "owa-client-types";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { getIsCopilotUIDisabled } from "owa-mail-copilot-settings/lib/selectors/getIsCopilotUIDisabled";
import { isMailboxSharedOrDelegateUserMailbox } from "owa-account-shared-mailbox-utils";
import hasBizChatLicense from "./hasBizChatLicense";
import hasM365CopilotLicense from "./hasM365CopilotLicense";

/**
 * Indicates whether a mailbox is eligible for an Inbox Rules Copilot experience.
 *
 * @param mailboxInfo The mailbox being checked (not the global/primary mailbox)
 * @returns {boolean} True when all mailbox prerequisites are satisfied.
 */
export const isInboxRulesCopilotEligible = (mailboxInfo: MailboxInfo): boolean => {
    const isAIEnabled = isGlobalFeatureEnabled("mon-copilot-bizchat") &&
        (hasBizChatLicense(mailboxInfo) || hasM365CopilotLicense(mailboxInfo));
    const isSharedOrDelegateMailbox = isMailboxSharedOrDelegateUserMailbox(mailboxInfo);
    
    return (isAIEnabled &&
        !isSharedOrDelegateMailbox &&
        !(mailboxInfo.type === "ArchiveMailbox") &&
        !getIsCopilotUIDisabled(mailboxInfo));
};

/**
 * Indicates whether the existing BizChat Inbox Rules entry point should be enabled.
 */
export const isInboxRulesCopilotEnabled = (mailboxInfo: MailboxInfo): boolean => isGlobalFeatureEnabled("settings-rules-bizchat") && isInboxRulesCopilotEligible(mailboxInfo);
